import { sylvanus } from '~/services/serviceInstances';

type ExtractDdeTableRequest = {
  modelId?: string;
  tableId: string;
};

type ServerExtractDdeTableResponse = {
  run_ids: string[];
  stream_id: string;
};

export type ExtractDdeTableResult = {
  runIds: string[];
};

const mapResponse = (
  response: ServerExtractDdeTableResponse,
): ExtractDdeTableResult => ({
  runIds: response.run_ids ?? [],
});

export const extractDdeTable = async ({
  modelId,
  tableId,
}: ExtractDdeTableRequest): Promise<ExtractDdeTableResult> => {
  const response = await sylvanus.post<ServerExtractDdeTableResponse>(
    `/dde/table/${tableId}/extract`,
    {},
    modelId ? { params: { model_id: modelId } } : undefined,
  );

  return mapResponse(response);
};
